import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import { Trans } from '@lingui/react';
import { useRouter } from 'next/router';
import Hero from '@ecosystems/landing_pages/hero/Hero';
import {
  TextWrapper,
  SubTitle,
  TextWrapperInner,
  ActionsWrapper,
} from '@ecosystems/landing_pages/hero/components';
import Button from '@components/buttons';
import { IOS_APP_LINK, ANDROID_APP_LINK } from '@lib/constants';

const HeroSection = styled(Hero)`
  position: relative;
  background-color: #dff4ff;

  ${TextWrapper} {
    padding: 40px 10px;
    margin: 0 auto;

    ${TextWrapperInner} {
      max-width: 800px;
      color: #3c3c3c;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin: 0 auto;

      ${SubTitle} {
        font-size: 24px;
      }

      ${ActionsWrapper} {
        flex-wrap: wrap;
        justify-content: center;
      }
    }

    a {
      border: none;
      margin: 0 10px;
    }

    a img {
      height: 50px;
    }
  }

  @media (min-width: ${({ theme }) => theme.viewports.tablet}px) {
    ${TextWrapper} {
      width: 80%;
    }

    ${SubTitle} {
      font-size: 34px;
    }
  }
`;

const MobileAppSection = () => {
  const {
    query: { lang },
  } = useRouter();

  return (
    <HeroSection
      title={<Trans id="landingpage.mobileapp_section.title" />}
      subtitle={<Trans id="landingpage.mobileapp_section.desc" />}
      actions={[
        <Button
          key="1"
          appearance="link"
          href={IOS_APP_LINK}
          target="_blank"
          rel="noopener"
        >
          <Image
            alt=""
            width={150}
            height={50}
            src={
              lang !== 'se'
                ? '/static/App_Store_Badge_en.svg'
                : '/static/App_Store_Badge_se.svg'
            }
          />
        </Button>,
        <Button
          key="0"
          appearance="link"
          href={ANDROID_APP_LINK}
          target="_blank"
          rel="noopener"
        >
          <Image
            alt=""
            width={150}
            height={50}
            src={
              lang !== 'se'
                ? '/static/google-play-badge-en.png'
                : '/static/google-play-badge-SE.png'
            }
          />
        </Button>,
      ]}
    />
  );
};

export default MobileAppSection;
